module.exports = __webpack_public_path__ + "img/eg.89b1f935.svg";